import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Image from '../../../../../config/images/gambar';

function PrintKHS(bahasa, prodi) {
    const doc = new jsPDF();
    var imageAsia = Image.data
    doc.addImage(imageAsia, 'JPEG', 95, 6, 19, 19)
    var width = doc.internal.pageSize.getWidth()
    doc.setFont("Times-bold", "bold")
    doc.setFontSize(11.5);
    doc.text('INSTITUT TEKNOLOGI DAN BISNIS ASIA MALANG', width / 2, 31, { align: 'center' });
    let fakultas;
    if (bahasa == 'indonesia') {
        if (prodi == "Teknik Informatika" || prodi == "Sistem Komputer" || prodi == "Desain Komunikasi Visual") {
            fakultas = "FAKULTAS TEKNOLOGI DAN DESAIN"
        } else if (prodi == "Akuntansi" || prodi == "Manajemen") {
            fakultas = "FAKULTAS EKONOMI DAN BISNIS"
        }
    } else if (bahasa == "english") {
        if (prodi == "Teknik Informatika" || prodi == "Sistem Komputer" || prodi == "Desain Komunikasi Visual") {
            fakultas = "FACULTY OF TECHNOLOGY AND DESIGN"
        } else if (prodi == "Akuntansi" || prodi == "Manajemen") {
            fakultas = "FACULTY OF ECONOMY AND BUSINESS"
        }
    }
    doc.setFont("Times-bold", "bold");
    doc.setFontSize(11.5);
    doc.text(fakultas, width / 2, 36.5, { align: 'center' });

    let jalan;
    if (bahasa == 'indonesia') {
        jalan = 'Jl. Soekarno-Hatta, Rembuksari 1A Malang Telp.(0341) 478877 Fax.(0341) 4345225'
    } else if (bahasa == "english") {
        jalan = 'Soekarno-Hatta Street, Rembuksari 1A Malang Telp.(0341) 478877 Fax.(0341) 4345225'
    }
    doc.setFont("Times-Roman", "normal");
    doc.setFontSize(11.5);
    doc.text(jalan, width / 2, 41.5, { align: 'center' });

    doc.setLineWidth(0.1)
    doc.line(10, 47, 200, 47)

    doc.setFont("Times-bold", "bold");
    doc.setFontSize(11.5);

    let judul;
    if (bahasa == 'indonesia') {
        judul = "KARTU HASIL STUDI"
    } else if (bahasa == "english") {
        judul = "STUDY RESULT CARD"
    }
    doc.text(judul, width / 2, 56, { align: 'center' });

    let drawCell = function (data) {
        var doc = data.doc;
        var rows = data.table.body;
        var i;
        for (i = 1; i < 5; i++) {
            if (data.row.index === rows.length - i) {
                doc.setFont("Times-Roman", "bold");
            }
        }
    };

    doc.autoTable({
        html: '#headerTabel',
        startY: doc.lastAutoTable + 63,
        theme: 'plain',
        styles: {
            font: 'times',
            lineColor: 'black',
            textColor: 'black',
            fontSize: '10.5',
            cellPadding: 0.5
        },
        margin: { left: 10, right: 10 }
    });

    doc.autoTable({
        html: '#tabelMK',
        theme: 'grid',
        styles: {
            font: 'times',
            lineColor: 'black',
            textColor: 'black',
        },
        headStyles: {
            fillColor: [255, 255, 255],
            lineColor: 'black',
            halign: 'center',
            cellWidth: 'wrap',
            lineWidth: 0.1
        },
        columnStyles: {
            0: { cellWidth: 8, halign: 'center' },
            1: { cellWidth: 40, halign: 'center' },
            3: { cellWidth: 80 },
            5: { halign: 'center' },
            6: { halign: 'center' },
            7: { halign: 'center' },
            8: { halign: 'center' },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 10 },
        willDrawCell: drawCell,
    });

    doc.autoTable({
        html: '#ttd',
        theme: 'plain',
        styles: {
            font: 'times',
            lineColor: 'black',
            textColor: 'black',
            fontSize: '10.5',
            cellPadding: 0.1
        },
        margin: { top: 20, left: 10, right: 10, bottom: 10 },
        columnStyles: {
            0: { halign: 'center' },
            1: { halign: 'center' }
        },
        didParseCell: function (data) {
            var rows = data.table.body;
            if (data.row.index === rows.length - 2) {
                data.cell.styles.cellPadding = -4
            }
            if (data.row.index === rows.length - 1) {
                data.cell.styles.cellPadding = 1
            }
        }
    });

    window.open(doc.output('bloburl'), '_blank')

    return null
}

export default PrintKHS;